<template>
  <div id="app">
    <div v-if="isLoading" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
      <p>Loading...</p>
    </div>

    <div v-show="!isLoading">
      <bulmaLogin v-if="!$store.getters.connection_id" />
     <router-view v-if="$store.getters.connection_id"/>

    </div>
  </div>
</template>

<script>
import bulmaLogin from './components/bulma_login.vue'

export default {
  name: 'app',
  components: {
    bulmaLogin,
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      console.log('cambio route')

      if (to.query && to.query.logout) {
        this.handleLogout();
      }

      if (window.OpenReplay) window.OpenReplay.issue(to.params.process + (to && to.params && to.params.verb ? '/' + to.params.verb : ''), to)
      if (this.$store.state.overrideKey || this.$store.state.overrideUser) {
        if (window.OpenReplay) window.OpenReplay.issue('override', { overrideKey: this.$store.state.overrideKey, overrideUser: this.$store.state.overrideUser })
      }

      // gestione chiusura pop-up tramite back del browser
      if (this.$store.state.process_stack.length > 0 && from.params.verb == 'd' && !to.params.verb) {
        console.log('POPUP APERTI')
        this.$store.commit('POP_PROCESS_STATUS')
        window.history.forward()
      }
    }
  },
  computed: {
    // Keeps the loader visible until BOTH the config is ready AND auth is finished
    isLoading() {
      return !this.$store.getters.isConfigLoaded || this.isProcessingAuth;
    }
  },
  data: function () {
    return {
      isProcessingAuth: true, // Starts as true to block the UI
    };
  },

  created: async function () {
    try {
      // 1. Fetch the config from the backend first
      await this.$store.dispatch('fetchClientConfig');

        // Ensure Vue Router has finished parsing the initial URL before proceeding
      if (this.$router && this.$router.onReady) {
        await new Promise(resolve => this.$router.onReady(resolve));
      }

      // 2. Await the initialization
      const isRedirecting = await this.initializeApp();

      // 3. Only turn off the loading screen if the app ISN'T actively redirecting away
      if (!isRedirecting) {
        this.isProcessingAuth = false;
      }
    } catch (error) {
      console.error("Critical error during app initialization:", error);
      this.isProcessingAuth = false; // Failsafe
    }
  },

  methods: {
    async initializeApp() {
      // 0 guard // TODO we can remove this but then logout will not be working we need to chnage it where it needs to be chnaged
      if (window.location.search) {
        console.warn("Intercepted malformed URL structure. Moving query parameters behind hash...");

        // Rebuild the URL: Origin + Path + '#/' + whatever the query string was
        const fixedUrl = window.location.origin + window.location.pathname + '#/' + window.location.search;

        // Redirect instantly to the properly structured URL
        window.location.replace(fixedUrl);
        return true; // Stop execution here; the browser will reboot with the correct URL layout
      }

      // 1 read from query
      const query = this.$route.query;
      console.log("this.$route:", this.$route); // TODO remove later
      console.log("query:", query); // TODO remove later

      // 2 override function 
      this.overrideUser(query);

      // 3 logout (in case it exist)
      if (query.logout) {
        await this.handleLogout();
        return true;
      }

      // 4 login token
      if (query.token2) {
        const isRedirecting = await this.loginToken(query.token2);
        if (isRedirecting) return true;
      }

      const urlToken = query.token;
      const urlUser = query.user;
      const retPath = query.retPath;

      if (!this.$store.getters.connection_id) {
        if (urlToken) {
          this.$store.commit('SET_CONNECTION_ID', urlToken);
          this.$store.commit('SET_USER_ID', urlUser);

          let res;
          if (this.$store.getters.connection_id) {
            console.log('firing myprofile /n');
            res = await this.$store.dispatch('myprofile');
            console.log('myprofile:', res.myprofile);
          }

          if (window.OpenReplay) {
            console.log("urlUser!",urlUser);
            console.log("res.myprofile.user!",res.myprofile.user);
            window.OpenReplay.setUserID(urlUser);
          }
          if (window.OpenReplay && !urlUser && res) window.OpenReplay.setUserID(res.myprofile.user);

          if (retPath) {
            this.$router.replace({ path: retPath, query: {} }).catch(() => { });
            return false;
          }
        }
        else {
          console.log('login needed')
        }
      }
      else {
        try {
          let res = await this.$store.dispatch('myprofile');
          console.log('myprofile in else block:', res ? res.myprofile : 'no profile loaded');

          if (res && res.myprofile) {
            this.$store.commit('SET_CONNECTION_ID', res.token);
            this.$store.commit('SET_USER_ID', res.myprofile.user);
            if (window.OpenReplay) window.OpenReplay.setUserID(res.myprofile.user);
          } else {
            // If myprofile fails to return valid data, trigger logout
            throw new Error("Failed to load profile");
          }

          // 2. Validate existing session (Legacy code requirement)
          let valid = await this.$store.dispatch('validate_login');
          if (!valid) {
            console.log('Token non valido nella validate login');
            throw new Error("Legacy validation failed");
          }

        } catch (error) {
          console.error("Session error:", error);
          await this.$store.dispatch('logout');
          if (window.location.href !== window.location.origin + '/#/') {
            window.location.href = '/';
            return true; // Keep loading while redirecting to root
          }
        }
      }

      // If we reach this point, no redirects occurred. 
      // Safe to turn off the loader and render the app/login screen.
      return false;
    },

    async handleLogout() {
      await this.$store.dispatch('logout');
      // Clean the URL using Vue Router
      this.$router.replace({ query: {} }).catch(() => { });
      window.location.reload();
    },

    async loginToken(token2) {
      const response = await this.$store.dispatch('loginToken', { token2 });
      if (response) {
        console.log("something? token? ", token2);
        console.log("something? response? ", response);
        console.log("something? response? ", response.redirectUrl);

        window.location.href = response.redirectUrl;
        window.location.reload();
        return true;
      }
      return false;
    },


    overrideUser(query) {
      console.log ("overrideUser !!!!",query );

      if (query.overrideKey) {
        this.$store.commit('SET_OVERRIDEKEY', query.overrideKey);
        console.log("overrideKey",query.overrideKey);
      }

      
      if (query.overrideUser) this.$store.commit('SET_OVERRIDEUSER', query.overrideUser);
      if (query.overrideAccount) this.$store.commit('SET_OVERRIDEACCOUNT', query.overrideAccount);
    }
  }
}
</script>

<style></style>